import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { DownloadOutlined, ExportOutlined, ReloadOutlined, UserSwitchOutlined } from '@ant-design/icons';
import { Modal, DatePicker, TreeSelect, Tabs, Button, Card } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import CustomerAddForm from '../customers/CustomerAddForm';
import { checkPermission } from '@/utils/permission';
import { cleanObject, makeTree, CustomerServiceStatus } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import CustomerScheduleDetail from '../customers/CustomerScheduleDetail';
import moment from 'moment';
import { exportExcel, removeCustomer } from '@/redux/actions/customerActions';
import { getListLookupCustomer } from '@/redux/actions/LookupCustomerActions';
import DynamicTable from '@/components/DynamicTable';
import TelesaleFollowUpAssignForm from '@/components/TelesaleFollowUpAssignForm';
import { fetchFilters } from '@/redux/actions/filterActions';
import { buildCustomerColumns } from '@/columns/buildCustomerColumns';
import html2canvas from 'html2canvas';
import BaseNumberRangeFilter from '@/components/BaseNumberRangeFilter';
import FilterableMultiTreeSelect from '@/components/FilterableMultiTreeSelect';
import FilterableMultiSelect from '@/components/FilterableMultiSelect';
import { NotificationManager } from 'react-notifications';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/lookup-customer',
        breadcrumbName: 'Tra cứu khách hàng',
    },
]


class LookupCustomerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            isOpenAddForm: false,
            currentData: null,
            isTelesaleAssignOpen: false,
            loadingCapture: false,
            isLoadingExport: false
        }

        this.tableRef = createRef();
    }

    getQuery = (props = this.props) => {
        return qs.parse(props.location.search.slice(1));
    };

    componentDidMount() {
        this.loadData(this.getQuery());
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            this.loadData(this.getQuery(nextProps));
        }
    }

    componentDidUpdate(prevProps) {
        const prevQuery = qs.parse(prevProps.location.search.slice(1));
        const query = qs.parse(this.props.location.search.slice(1));

        // Revenue custom
        if ((query.revenue_from || query.revenue_to) && query.revenue_range !== 'custom') {
            this.handleRevenueChange('custom');
        }

        // paid custom
        if ((query.paid_from || query.paid_to) && query.paid_range !== 'custom') {
            this.handlePaidChange('custom');
        }

        // debt custom
        if ((query.debt_from || query.debt_to) && query.debt_range !== 'custom') {
            this.handleDebtChange('custom');
        }

        // rate custom
        if ((query.collect_rate_from || query.collect_rate_to) && query.collect_rate_range !== 'custom') {
            this.handleCollectRateChange('custom');
        }
    }


    onChangeFilter(name, value) {
        let query = qs.parse(this.props.location.search.slice(1));

        const handleDateRange = (startKey, endKey, dateValue) => {
            if (dateValue && dateValue.length > 0) {
                query[startKey] = moment(dateValue[0]).format('YYYY-MM-DD');
                query[endKey] = moment(dateValue[1]).format('YYYY-MM-DD');
            } else {
                delete query[startKey];
                delete query[endKey];
            }
        };

        if (name === 'created_at') {
            handleDateRange('created_date_from', 'created_date_to', value);
        } else if (name === 'appointment_schedule') {
            handleDateRange('appointment_schedule_from', 'appointment_schedule_to', value);
        } else if (name === 'care_date') {
            handleDateRange('care_date_from', 'care_date_to', value);
        } else if (name === 'usage_date') {
            handleDateRange('usage_date_from', 'usage_date_to', value);
        } else {
            query[name] = value;
        }

        delete query.created_at;
        delete query.appointment_schedule;
        delete query.care_date;
        delete query.usage_date;

        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    openAddForm(isOpenAddForm) {
        this.setState({ isOpenAddForm: isOpenAddForm })
    }

    onRemove() {
        this.props.removeCustomer(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            this.loadData(this.getQuery());
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }

    openScheduleDetail(record) {
        this.setState({ isOpenScheduleDetail: true, currentData: record });
    }

    loadData(query) {
        this.setState({ isLoading: true });
        this.props.getListLookupCustomer(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({
            selectedRowKeys: [],
            isTelesaleAssignOpen: false,
        })
    }

    handleCaptureClick = async () => {
        this.setState({ loadingCapture: true });

        const table = this.tableRef.current;
        if (!table) return;

        // Tạo một bảng tạm thời với kích thước lớn
        const clonedTable = table.cloneNode(true);
        clonedTable.style.width = 'max-content';
        clonedTable.style.height = 'max-content';

        // Thêm bảng tạm thời vào body để tránh các ràng buộc CSS
        document.body.appendChild(clonedTable);

        // Chụp ảnh của bảng tạm thời
        await html2canvas(clonedTable).then(canvas => {
            // Chuyển canvas thành hình ảnh và tải xuống
            const imgData = canvas.toDataURL('image/jpg');
            const link = document.createElement('a');
            const d = new Date();
            const f = (n) => (`0${n}`).slice(-2);
            link.href = imgData;
            link.download = `khach-hang-${[f(d.getDate()), f(d.getMonth() + 1), d.getFullYear(), f(d.getHours()), f(d.getMinutes())].join('-')}.jpg`;
            link.click();

            // Loại bỏ bảng tạm thời sau khi đã chụp ảnh
            document.body.removeChild(clonedTable);
        });
        this.setState({ loadingCapture: false });
    };

    handleRevenueChange = (value) => {
        let query = qs.parse(this.props.location.search.slice(1));

        // Clear hết
        if (!value) {
            delete query.revenue_range;
            delete query.revenue_from;
            delete query.revenue_to;
        }
        // Custom
        else if (value === 'custom') {
            query.revenue_range = 'custom';
            // KHÔNG xóa from/to để user nhập
        }
        // Preset
        else {
            query.revenue_range = value;
            delete query.revenue_from;
            delete query.revenue_to;
        }

        query.page = 1;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    };

    handlePaidChange = (value) => {
        let query = qs.parse(this.props.location.search.slice(1));

        // Clear
        if (!value) {
            delete query.paid_range;
            delete query.paid_from;
            delete query.paid_to;
        }
        // Custom
        else if (value === 'custom') {
            query.paid_range = 'custom';
        }
        // Preset
        else {
            query.paid_range = value;
            delete query.paid_from;
            delete query.paid_to;
        }

        query.page = 1;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    };

    handleDebtChange = (value) => {
        let query = qs.parse(this.props.location.search.slice(1));

        // Clear
        if (!value) {
            delete query.debt_range;
            delete query.debt_from;
            delete query.debt_to;
        }
        // Custom
        else if (value === 'custom') {
            query.debt_range = 'custom';
        }
        // Preset
        else {
            query.debt_range = value;
            delete query.debt_from;
            delete query.debt_to;
        }

        query.page = 1;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    };

    handleCollectRateChange = (value) => {
        let query = qs.parse(this.props.location.search.slice(1));

        // Clear
        if (!value) {
            delete query.collect_rate_range;
            delete query.collect_rate_from;
            delete query.collect_rate_to;
        }
        // Custom
        else if (value === 'custom') {
            query.collect_rate_range = 'custom';
        }
        // Preset
        else {
            query.collect_rate_range = value;
            delete query.collect_rate_from;
            delete query.collect_rate_to;
        }

        query.page = 1;
        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    };

    startExcelExport() {
        const { authUser } = this.props;

        const query = qs.parse(this.props.location.search.slice(1));

        this.setState({ isLoadingExport: true });

        // Gọi API exportExcel, nhưng không chờ response
        this.props.exportExcel(query).catch(() => {
            NotificationManager.error(
                "Có lỗi xảy ra trong quá trình gửi yêu cầu xuất file. Vui lòng thử lại sau.",
                "Lỗi",
                9000
            );
        }).finally(() => {
            this.setState({ isLoadingExport: false });
        });

        this.setState({ isLoadingExport: false });
        // Thông báo ngay lập tức cho người dùng
        NotificationManager.success(
            `Quá trình xuất file đang được thực hiện. 
            File kết quả sẽ được gửi vào email ${authUser.user_email} trong ít phút.`,
            "Thông báo",
            9000
        );
    }

    render() {
        var { pagination,
            lookup_customerList,
            users, doctors,
            filterData, consultants
        } = this.props;
        var { isLoading, selectedRowKeys,
            isOpenAddForm,
            currentData,
            isOpenScheduleDetail,
            isTelesaleAssignOpen,
            loadingCapture,
            isLoadingExport
        } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const customerIds = selectedRowKeys;
        const list_provinces = filterData?.provinces;
        const customer_source_active_list = filterData?.sources;
        const branchActiveList = filterData?.branches;
        const customerInteractiveTypeActiveList = filterData?.interactive_types;
        const customerInteractiveStatusActiveList = filterData?.interactive_statuses;
        const customerStatusActiveList = filterData?.statuses;
        const service_active_list = filterData?.services;

        const service = makeTree(service_active_list || [], 0);

        const REVENUE_PRESETS = [
            { value: '0_10m', label: '0 - 10 triệu' },
            { value: '10_30m', label: '10 - 30 triệu' },
            { value: '30_50m', label: '30 - 50 triệu' },
            { value: 'gt_50m', label: '≥ 50 triệu' },
            { value: 'custom', label: 'Tùy chỉnh' },
        ];

        const columns = buildCustomerColumns(
            {
                onOpenScheduleDetail: (record) => this.openScheduleDetail(record),
                loadData: () => this.loadData(this.getQuery()),
                showCardNumber: true
            },
            {
                // Ghi đè thuộc tính cột:
                overrides: {
                    full_name: { width: 300 },
                }
            }
        );

        const tables = <DynamicTable
            dataSource={lookup_customerList || []}
            columns={columns}
            isLoading={isLoading}
            pagination={pagination}
            rowSelection={rowSelection}
            moduleKey="lookup_customer"
            onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
        />

        const allowedExport = checkPermission('customer', 'export');

        return (
            <div>
                <PageTitle routes={routes} title="Khách hàng" />
                <div>
                    <TableActionBar
                        isShowAddButton={checkPermission('customer', 'create')}
                        isShowDeleteButton={checkPermission('customer', 'remove')}
                        onAdd={() => this.openAddForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        filterColSpan={6}
                        activeFilter={
                            query.created_date_from ||
                            query.usage_date_from ||
                            query.appointment_schedule_start ||
                            query.customer_status_id ||
                            query.interested_service_id ||
                            query.selected_service_id ||
                            query.interaction_type_id ||
                            query.interaction_status_id ||
                            query.province_code ||
                            query.branch_id ||
                            query.customer_source_id ||
                            query.service_status ||
                            query.doctor_charge ||
                            query.consultant_staff ||
                            query.care_date_from ||
                            query.care_staff_id ||
                            query.revenue_range ||
                            query.revenue_from ||
                            query.revenue_to ||
                            query.paid_range ||
                            query.paid_from ||
                            query.paid_to ||
                            query.debt_range ||
                            query.debt_from ||
                            query.debt_to ||
                            query.collect_rate_range ||
                            query.collect_rate_from ||
                            query.collect_rate_to
                        }
                        filters={
                            [
                                <BaseSelect
                                    options={branchActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    placeholder="Chọn cơ sở"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('branch_id', value)}
                                    defaultValue={query.branch_id ? parseInt(query.branch_id) : null}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày tạo', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_at', value)}
                                    defaultValue={[query.created_date_from ? moment(query.created_date_from, 'YYYY-MM-DD') : null, query.created_date_to ? moment(query.created_date_to, 'YYYY-MM-DD') : null]}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày chốt', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('usage_date', value)}
                                    defaultValue={[query.usage_date_from ? moment(query.usage_date_from, 'YYYY-MM-DD') : null, query.usage_date_to ? moment(query.usage_date_to, 'YYYY-MM-DD') : null]}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Lịch hẹn', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('appointment_schedule', value)}
                                    defaultValue={[query.appointment_schedule_start ? moment(query.appointment_schedule_start, 'YYYY-MM-DD') : null, query.appointment_schedule_end ? moment(query.appointment_schedule_end, 'YYYY-MM-DD') : null]}
                                />,
                                <FilterableMultiSelect
                                    options={customerStatusActiveList || []}
                                    placeholder="Trạng thái khách hàng"
                                    parameterName='customer_status_id'
                                    optionValue="id"
                                    optionLabel="name"
                                />,
                                <TreeSelect
                                    showSearch
                                    className="w-100"
                                    dropdownStyle={{ maxHeight: 450, overflow: 'auto' }}
                                    treeData={service}
                                    treeNodeFilterProp='title'
                                    allowClear
                                    placeholder="Dịch vụ quan tâm"
                                    treeDefaultExpandAll
                                    defaultValue={query.interested_service_id ? parseInt(query.interested_service_id) : null}
                                    onChange={(value) => this.onChangeFilter('interested_service_id', value)}
                                />,
                                <FilterableMultiTreeSelect
                                    options={service || []}
                                    placeholder="Dịch vụ chốt"
                                    parameterName='selected_service_id'
                                />,
                                <BaseSelect
                                    options={CustomerServiceStatus || []}
                                    optionValue="value"
                                    optionLabel="label"
                                    showSearch
                                    placeholder="Trạng thái dịch vụ chốt"
                                    onChange={(value) => this.onChangeFilter('service_status', value)}
                                    className="w-100"
                                    defaultValue={query.service_status ? query.service_status : null}
                                />,
                                <BaseSelect
                                    options={customerInteractiveTypeActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    showSearch
                                    placeholder="Loại tương tác"
                                    onChange={(value) => this.onChangeFilter('interaction_type_id', value)}
                                    className="w-100"
                                    defaultValue={query.interaction_type_id ? parseInt(query.interaction_type_id) : null}
                                />,
                                <BaseSelect
                                    options={customerInteractiveStatusActiveList || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    showSearch
                                    placeholder="Trạng thái tương tác"
                                    onChange={(value) => this.onChangeFilter('interaction_status_id', value)}
                                    className="w-100"
                                    defaultValue={query.interaction_status_id ? parseInt(query.interaction_status_id) : null}
                                />,
                                <BaseSelect
                                    options={list_provinces || []}
                                    optionValue="code"
                                    optionLabel="name"
                                    showSearch
                                    placeholder="Tỉnh/Thành phố"
                                    className="w-100"
                                    onChange={(value) => {
                                        this.onChangeFilter('province_code', value);
                                    }}
                                    defaultValue={query.province_code ? query.province_code : null}
                                />,
                                <BaseSelect
                                    options={customer_source_active_list || []}
                                    optionValue="id"
                                    optionLabel="name"
                                    showSearch
                                    placeholder="Nguồn khách hàng"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('customer_source_id', value)}
                                    defaultValue={query.customer_source_id ? parseInt(query.customer_source_id) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Người tạo"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('created_by', value)}
                                    defaultValue={query.created_by ? parseInt(query.created_by) : null}
                                />,
                                <BaseSelect
                                    options={doctors || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Bác sĩ thực hiện"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('doctor_charge', value)}
                                    defaultValue={query.doctor_charge ? parseInt(query.doctor_charge) : null}
                                />,
                                <BaseSelect
                                    options={users || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên tư vấn"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('consultant_staff', value)}
                                    defaultValue={query.consultant_staff ? parseInt(query.consultant_staff) : null}
                                />,
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    placeholder={['Ngày CSKH', 'Đến ngày']}
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('care_date', value)}
                                    defaultValue={[query.care_date_from ? moment(query.care_date_from, 'YYYY-MM-DD') : null, query.care_date_to ? moment(query.care_date_to, 'YYYY-MM-DD') : null]}
                                />,
                                <BaseSelect
                                    options={consultants || []}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    showSearch
                                    placeholder="Nhân viên CSKH"
                                    className="w-100"
                                    onChange={(value) => this.onChangeFilter('care_staff_id', value)}
                                    defaultValue={query.care_staff_id ? parseInt(query.care_staff_id) : null}
                                />,
                                <BaseSelect
                                    options={REVENUE_PRESETS}
                                    optionValue="value"
                                    optionLabel="label"
                                    placeholder="Doanh số"
                                    className="w-100"
                                    allowClear
                                    defaultValue={query.revenue_range || null}
                                    onChange={this.handleRevenueChange}
                                />,
                                query.revenue_range === 'custom' && (
                                    <BaseNumberRangeFilter
                                        name="revenue"
                                        query={query}
                                        onChangeFilter={this.onChangeFilter.bind(this)}
                                        placeholder={['Từ (VNĐ)', 'Đến (VNĐ)']}
                                        step={100000}
                                    />
                                ),
                                <BaseSelect
                                    options={REVENUE_PRESETS}
                                    optionValue="value"
                                    optionLabel="label"
                                    placeholder="Đã thanh toán"
                                    className="w-100"
                                    allowClear
                                    defaultValue={query.paid_range || undefined}
                                    onChange={this.handlePaidChange}
                                />,
                                query.paid_range === 'custom' && (
                                    <BaseNumberRangeFilter
                                        name="paid"
                                        query={query}
                                        onChangeFilter={this.onChangeFilter.bind(this)}
                                        placeholder={['Từ (VNĐ)', 'Đến (VNĐ)']}
                                        step={100000}
                                    />
                                ),
                                <BaseSelect
                                    options={[
                                        { label: '< 30%', value: 'lt_30' },
                                        { label: '30 - 49%', value: '30_50' },
                                        { label: '50 - 79%', value: '50_80' },
                                        { label: '80 - 99%', value: '80_99' },
                                        { label: '100%', value: 'eq_100' },
                                        { value: 'custom', label: 'Tùy chỉnh' },
                                    ]}
                                    optionValue="value"
                                    optionLabel="label"
                                    placeholder="Tỷ lệ thu"
                                    className="w-100"
                                    allowClear
                                    defaultValue={query.collect_rate_range || undefined}
                                    onChange={this.handleCollectRateChange}
                                />,
                                query.collect_rate_range === 'custom' && (
                                    <BaseNumberRangeFilter
                                        name="collect_rate"
                                        query={query}
                                        onChangeFilter={this.onChangeFilter.bind(this)}
                                        placeholder={['Từ (%)', 'Đến (%)']}
                                        step={5}
                                    />
                                ),
                                <BaseSelect
                                    options={REVENUE_PRESETS}
                                    optionValue="value"
                                    optionLabel="label"
                                    placeholder="Còn nợ"
                                    className="w-100"
                                    allowClear
                                    defaultValue={query.debt_range || undefined}
                                    onChange={this.handleDebtChange}
                                />,
                                query.debt_range === 'custom' && (
                                    <BaseNumberRangeFilter
                                        name="debt"
                                        query={query}
                                        onChangeFilter={this.onChangeFilter.bind(this)}
                                        placeholder={['Từ (VNĐ)', 'Đến (VNĐ)']}
                                        step={100000}
                                    />
                                )
                            ]
                        }
                    >
                        {
                            checkPermission('telesale_follow_up', 'assign') ? (
                                <Button icon={<UserSwitchOutlined />} className="table-button" type='primary' disabled={!selectedRowKeys.length ? true : false} onClick={() => this.setState({ isTelesaleAssignOpen: true })}>Giao cho telesale</Button>
                            ) : null
                        }
                        <Button className="table-button" type='primary' icon={<DownloadOutlined />} loading={loadingCapture} onClick={() => this.handleCaptureClick()}>Chụp màn hình</Button>
                        {
                            allowedExport ? (
                                <Button className="table-button" type='default' loading={isLoadingExport} onClick={() => this.startExcelExport()} icon={<ExportOutlined />}>Export</Button>
                            ) : null
                        }
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(this.getQuery())}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>

                <Card size='small' bodyStyle={{ padding: 0 }}>
                    <Tabs onChange={(value) => this.onChangeFilter('tab', value)} defaultActiveKey={query.tab} type="card" size="small">
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Toàn bộ khách hàng</span>} key="all">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                        <TabPane tab={<span style={{ fontWeight: 600 }}>Khách hàng hôm nay</span>} key="today">
                            <div ref={this.tableRef}>
                                {tables}
                            </div>
                        </TabPane>
                    </Tabs>
                </Card>

                <CustomerAddForm
                    visible={isOpenAddForm}
                    onCancel={() => this.openAddForm(false)}
                    reloadData={() => this.loadData(this.getQuery())}
                />
                <CustomerScheduleDetail
                    visible={isOpenScheduleDetail}
                    currentItem={currentData}
                    onCancel={() => this.setState({ isOpenScheduleDetail: false })}
                />
                <TelesaleFollowUpAssignForm
                    visible={isTelesaleAssignOpen}
                    customer_ids={customerIds}
                    onCancel={() => this.onCancel()}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        lookup_customerList: state.LookupCustomerReducer.lookup_customerList,
        pagination: state.LookupCustomerReducer.pagination,
        users: state.config.users,
        doctors: state.config.doctors,
        consultants: state.config.consultants,
        filterData: state.filterReducer.list,
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListLookupCustomer: (filter) => dispatch(getListLookupCustomer(filter)),
        removeCustomer: (ids) => dispatch(removeCustomer(ids)),
        fetchFilters: () => dispatch(fetchFilters()),
        exportExcel: (filter) => dispatch(exportExcel(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'LookupCustomerList' })(LookupCustomerList));

